/*jshint esversion: 6 */
document.addEventListener("DOMContentLoaded", function () {

    // make the sticky magic happen on the menu
    let scrolled_val = 0;

    // for the initial position
    scrolled_val = window.scrollY;
    if(scrolled_val > 49) { 
        document.querySelector('header.sticky-top').classList.add('is-pinned');
    }
    
    // for when it scrolls
    window.addEventListener('scroll', (e) => {
        scrolled_val = window.scrollY;
        if(scrolled_val <= 49) { 
            document.querySelector('header.sticky-top').classList.remove('is-pinned');
        } else {
            document.querySelector('header.sticky-top').classList.add('is-pinned');
        }
    });

    // Enable tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // Tooltip me if truncated text being truncated
    function callTooltip(element,elementTitle) {
        const tooltip = new bootstrap.Tooltip(element, {
            title: elementTitle,
            customClass: 'card-tooltip',
        });
        element.addEventListener('mouseenter', () => {
            tooltip.toggle();
        });
        element.addEventListener('mouseleave', () => {
            tooltip.toggle();
        });
    }
    const textTruncateElements = document.querySelectorAll('.text-truncate');

    for (const textTruncateElement of textTruncateElements) {
        if (textTruncateElement.scrollWidth > textTruncateElement.clientWidth) {
            const textTruncateTitle = textTruncateElement.textContent;
            callTooltip(textTruncateElement,textTruncateTitle);
        }
    }


    // Speedbump Links
    document.querySelectorAll("a.speed-bump").forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const href = this.getAttribute("href");
        const classList = Array.from(this.classList);

        // Find a custom speed-bump-* class, if any
        const customClass = classList.find(
          (cls) => cls.startsWith("speed-bump-") && cls !== "speed-bump"
        );

        // Determine modal and relay IDs
        let modalId, relayId;
        if (customClass) {
          const suffix = customClass.replace("speed-bump-", "");
          modalId = `speedbumpModal${suffix}`;
          relayId = `speedbump-relay-${suffix}`;
        } else {
          modalId = "speedbumpModaldefault";
          relayId = "speedbump-relay-default";
        }

        const modalEl = document.getElementById(modalId);
        const relayEl = document.getElementById(relayId);

        if (modalEl && relayEl) {
          relayEl.setAttribute("href", href);

          const modal = new bootstrap.Modal(modalEl);

          // Replace relay with clone to remove old click listeners (important for repeated clicks)
          const newRelay = relayEl.cloneNode(true);
          relayEl.replaceWith(newRelay);
          newRelay.addEventListener("click", () => modal.hide(), {
            once: true,
          });

          modal.show();
        } else {
          console.warn(`Speedbump modal or relay not found for: ${modalId}`);
        }
      });
    });
});